import { Table } from "antd";
import React from "react";
import { useCalculateComponentHeightSizeHook } from "../../hooks";
import PropTypes from "prop-types";

export const TableReport = ({ data = [], columns = [], loading = false }) => {
	const { tableHeight } = useCalculateComponentHeightSizeHook({heightDifference: 200});

	return (
		<Table
			size="small"
			dataSource={data}
			columns={columns}
			loading={loading}
			pagination={false}
			bordered
			scroll={{
				x: "max-content",
				y: tableHeight,
			}}
		/>
	);
};

TableReport.propTypes = {
	data: PropTypes.array,
	columns: PropTypes.array,
	loading: PropTypes.bool,
};